var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-pinterest",on:{"click":function($event){return _vm.$emit('click')}}},[_c('helio-icon',{attrs:{"token":"pinterest-p","weight":"brand"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }